import { useTranslation } from 'react-i18next'

import { format, utcToZonedTime } from 'date-fns-tz'
import parseISO from 'date-fns/parseISO'

import { formatDateLocale } from '@probatix/common/utils/date'

export const formatInTimeZone = (date, fmt, tz) => format(utcToZonedTime(date, tz), fmt, { timeZone: tz })
export const defaultTimeZone = 'Europe/Berlin'

const useFormattedDateTime = () => {

  const { i18n } = useTranslation()

  const completeDateFormat = `d${'en' !== i18n.language ? 'o' : ''} MMM y`
  const completeDateFormat2 = `d${'en' !== i18n.language ? 'o' : ''} MMM yy`

  const formattedLocaleDaysDateTime = (currentTime) => formatDateLocale(new Date(currentTime), 'EE d MMM, HH:mm')
  const formattedLocaleDateTime = (currentTime) => formatDateLocale(new Date(currentTime), 'd. MMM yyyy, HH:mm')

  const endTime = (tempDate) => {

    const tempEndTime = new Date(tempDate)
    tempEndTime.setMinutes(tempEndTime.getMinutes() + 15)

    return tempEndTime
  }

  const googleStartTime = (tempDate) => formatInTimeZone(parseISO(tempDate), "yyyyMMdd'T'HHmmss", defaultTimeZone)
  const googleEndTime = (tempDate) =>
    formatInTimeZone(parseISO(endTime(tempDate).toISOString()), "yyyyMMdd'T'HHmmss", defaultTimeZone)

  const outlookStartTime = (tempDate) =>
    formatInTimeZone(parseISO(tempDate), "yyyy-MM-dd'T'HH:mm:ss", defaultTimeZone)

  const outlookEndTime = (tempDate) =>
    formatInTimeZone(parseISO(endTime(tempDate).toISOString()), "yyyy-MM-dd'T'HH:mm:ss", defaultTimeZone)

  const formattedLocaleDateWithoutDayOfWeek = (time) => formatDateLocale(new Date(time!), completeDateFormat)
  const formattedLocaleDateWithoutDayOfWeek2DigitYear = (time) =>
    formatDateLocale(new Date(time!), completeDateFormat2)

  return {
    formattedLocaleDateTime,
    formattedLocaleDateWithoutDayOfWeek,
    formattedLocaleDateWithoutDayOfWeek2DigitYear,
    formattedLocaleDaysDateTime,
    googleEndTime,
    googleStartTime,
    outlookEndTime,
    outlookStartTime,
  }
}

export default useFormattedDateTime
